export const SET_SELECTED_CROP_AR_TYPE = 'SET_SELECTED_CROP_AR_TYPE';

export const SET_STANDARD_CROP = 'SET_STANDARD_CROP';
export const SET_OLD_STANDARD_CROP = 'SET_OLD_STANDARD_CROP';
export const SET_NEW_STANDARD_CROP = 'SET_NEW_STANDARD_CROP';
export const SET_PORTRAIT_CROP = 'SET_PORTRAIT_CROP';
export const SET_WIDE_CROP = 'SET_WIDE_CROP';

export const SET_STANDARD_CROPPED_IMAGE_PREVIEW =
	'SET_STANDARD_CROPPED_IMAGE_PREVIEW';
export const SET_OLD_STANDARD_CROPPED_IMAGE_PREVIEW =
	'SET_OLD_STANDARD_CROPPED_IMAGE_PREVIEW';
export const SET_NEW_STANDARD_CROPPED_IMAGE_PREVIEW =
	'SET_NEW_STANDARD_CROPPED_IMAGE_PREVIEW';
export const SET_PORTRAIT_CROPPED_IMAGE_PREVIEW =
	'SET_PORTRAIT_CROPPED_IMAGE_PREVIEW';
export const SET_WIDE_CROPPED_IMAGE_PREVIEW = 'SET_WIDE_CROPPED_IMAGE_PREVIEW';
export const SET_SELECTED_IMG_REF = 'SET_SELECTED_IMG_REF';
